export class SearchBatchloadingdocument {
  batchloadingId: number;
  documentNumber: string;
  fullnamePerson: string;
  active: number;
}
